/**
 * Returns a full HTML document with a single anchor tag
 */
export function toHtmlLinkDocument(title: string, url: string): string {
    const escapedTitle = title.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    const escapedUrl = url
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    return (
        `<meta charset='utf-8'>` +
        `<html><head></head>` +
        `<body><a href="${escapedUrl}">${escapedTitle}</a></body></html>`
    );
}
